<template lang="html">
  <section :id="id" class="custom-display-element-expand-member">
    <custom-display-element-expand-item
      v-for="(memberProp, index) of member.props"
      :key="index"
      :id="`member-prop-${memberProp.name}`"
      :member-prop="memberProp"
      :translations="translations"
      :data-source="dataSource"
      :all-sources="allSources"
      :initial-expression="initialExpression(memberProp)"
      :app-type="appType"
      @on-member-field-updated="onMemberFieldSelected"
    />
    <custom-display-element-expand-item
      v-for="(memberProp, index) of customMemberProps"
      :key="`${newMemberPrefix}-${index}`"
      :id="`${newMemberPrefix}-${index}`"
      :member-prop="memberProp"
      :translations="translations"
      :data-source="dataSource"
      :all-sources="allSources"
      :initial-expression="initialExpression(memberProp)"
      :app-type="appType"
      @on-member-field-updated="onMemberFieldSelected"
      @on-member-field-remove="onMemberFieldRemove"
    />
    <div class="add-new">
      <button class="m-button" @click.stop="addNewCustomProp">
        {{ $t("addNew") }}
      </button>
    </div>
  </section>
</template>

<script lang="js">
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import CustomDisplayElementExpandItem from "@/components/custom-display-elements/page-elements/CustomDisplayElementExpandItem";

  export default  {
    name: "custom-display-element-expand-member",
    components: {
      CustomDisplayElementExpandItem
    },
    props: {
      id: String,
      member: {
        type: Object,
        default: function() {
          return {};
        }
      },
      translations: {
        type: Object,
        default: function() {
          return {};
        }
      },
      properties: {
        type: Object,
        default: function() {
          return {};
        }
      },
      dataSource: Object,
      allSources: Object,
      // custom member fields that are not from the manifest file
      customMemberFields: {
        type: Object,
        default: function() {
          return {};
        }
      },
      appType : String
    },
    data () {
      return {
        customMemberProps: [],
        customProps: {}
      }
    },
    computed: {
      newMemberPrefix() {
        return "custom-array-property";
      }
    },
    mounted() {
      this.setupExistingCustomProps();
    },
    methods: {
      initialExpression(prop) {
        return this.initialMemberCustomFieldExpression(prop) || this.initialMemberFieldExpression(prop);
      },
      initialMemberCustomFieldExpression(prop) {
        let expression;
        if(prop.customId) {
          const customFields = this.customMemberFields[this.member.name];
          expression = customFields? customFields[prop.customId].expression : null;
        }
        return expression;
      },
      initialMemberFieldExpression(prop) {
        const memberProps = this.properties[this.member.name];
        return memberProps.fields[prop.property];
      },
      onMemberFieldSelected(ctx) {
        if(ctx.memberProp.customId) {
          this.customProps[ctx.memberProp.customId].expression = ctx.expression;
        }
        this.$emit("on-member-expression-update", ctx);
      },
      onMemberFieldRemove(ctx) {
        delete this.customProps[ctx.member.customId];
        this.customMemberProps = this.customMemberProps.filter(e => e.customId !== ctx.member.customId);
        this.$emit("on-member-prop-delete", {id: this.id, memberProp: ctx.member});
      },
      addNewCustomProp() {
        const newProp = distributionChannelUtil.createNewCustomProp({name: this.member.name});
        this.addProp(newProp);
        this.$emit("on-member-expression-update", {id: this.id, memberProp: newProp, expression: null});
      },
      setupExistingCustomProps() {
        const customFields = this.customMemberFields[this.member.name];
        if(customFields) {
          for(const prop of Object.values(customFields)) {
            this.addProp(prop.memberProp, prop.expression);
          }
        }
      },
      addProp(newProp, expression) {
        this.customProps[newProp.customId] = {
          name: newProp.name,
          expression: expression || null
        };
        this.customMemberProps.push(newProp);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .custom-display-element-expand-member {
    .add-new {
      padding-bottom: 1rem;
    }
  }
</style>
